import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Topbar from './topbar/Topbar';
import Sidebar from './sidebar/Sidebar';

import { changeThemeToDark, changeThemeToLight } from '../../redux/actions/themeActions';
import {
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
  changeUserViewAs,
} from '../../redux/actions/sidebarActions';
import { SidebarProps } from '../../shared/prop-types/ReducerProps';
import { getCurrentUser } from '../../helpers/storage';

class Layout extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    sidebar: SidebarProps.isRequired,
    history: PropTypes.shape({}).isRequired,
  };

  changeSidebarVisibility = () => {
    const { dispatch } = this.props;
    dispatch(changeSidebarVisibility());
  };

  changeMobileSidebarVisibility = () => {
    const { dispatch } = this.props;
    dispatch(changeMobileSidebarVisibility());
  };

  changeToDark = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToDark());
  };

  changeToLight = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToLight());
  };

  changeUserView = (userType) => {
    const { dispatch, history } = this.props;
    dispatch(changeUserViewAs(userType));

    const user = JSON.parse(localStorage.getItem('currentUser')) || {};

    if (!user.id) {
      history.push('/');
      return;
    }

    if (userType === 0 && user.esAlumno) {
      history.push('/pages/student-dashboard');
      return;
    }

    if (userType === 1 && user.esProfesor) {
      history.push('/pages/profesor-dashboard');
      return;
    }

    history.push('/pages');
  };

  render() {
    const { sidebar, history } = this.props;
    const currentUser = getCurrentUser();

    const { publicSettings = {} } = currentUser;
    const { appEnvironment } = publicSettings;
    const { viewPageAs } = sidebar;
    const layoutClass = classNames({
      layout: true,
      'layout--collapse': sidebar.collapse,
    });


    if (!currentUser.id) {
      history.push('/');
      return null;
    }

    return (
      <div className={layoutClass}>
        <Topbar
          changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
          changeSidebarVisibility={this.changeSidebarVisibility}
          changeUserView={this.changeUserView}
          viewPageAs={viewPageAs}
          appEnvironment={appEnvironment}
        />
        <Sidebar
          sidebar={sidebar}
          changeToDark={this.changeToDark}
          changeToLight={this.changeToLight}
          changeMobileSidebarVisibility={this.changeMobileSidebarVisibility}
          viewPageAs={viewPageAs}
        />
      </div>
    );
  }
}

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(Layout));
